import GuessSeasonQuiz from "../../components/Nursery/EnvironmentScience/GuessSeasonQuiz";
import MatchSeasons from "../../components/Nursery/EnvironmentScience/MatchSeasons";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


document.title = "Mamas Guidance - Nursery - Environmental Science - Seasons"; // Set page title


const topics: MenuItem[] = [
    { url: "/nursery/environmental-science/seasons/guess-seasons", title: "Guess The Season", component: GuessSeasonQuiz},
   // { url: "/nursery/environmental-science/seasons/match-seasons", title: "Match Seasons", component: MatchSeasons},
];


export default topics;